<template>
  <div class="alarmlist">
    <van-nav-bar title="报警列表" :fixed="true" />
    <div class="body">
      <van-pull-refresh v-model="isLoading" @refresh="getAlarmList" style="width: 100%;overflow: auto">
        <el-table :data="alarmList">
          <el-table-column type="expand" width="20">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="名称：">
                  <span>{{ props.row.station_name }}</span>
                </el-form-item>
                <el-form-item label="设备号：">
                  <span>{{ props.row.sn }}</span>
                </el-form-item>
                <!-- <el-form-item label="设备类型：">
                  <span>{{ props.row.station_type_name || '--'}}</span>
                </el-form-item> -->
                <el-form-item label="报警类型：">
                  <span>{{ props.row.type_name }}</span>
                </el-form-item>
                <el-form-item label="报警值：">
                  <span>{{ props.row.value }}</span>
                  <span style="color: darkgrey;font-size: 12px;">
                    {{getUnit(props.row.data_type)}}
                  </span>
                </el-form-item>
                <!-- <el-form-item label="区县：">
                  <span>{{ props.row.quxian_name || '--' }}</span>
                </el-form-item>
                <el-form-item label="街道办：">
                  <span>{{ props.row.jiedaoban_name || '--' }}</span>
                </el-form-item> -->
                <el-form-item label="开始时间：" style="width: 100%">
                  <span>{{ props.row.start_time }}</span>
                </el-form-item>
                <el-form-item label="更新时间：">
                  <span>{{ props.row.update_time }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column label="#" type="index" width="30"></el-table-column>
          <el-table-column label="报警站点" prop width="120">
            <template slot-scope="scope">{{scope.row.station_name}}</template>
          </el-table-column>

          <el-table-column label="报警类型" prop width="100">
            <template slot-scope="scope">{{scope.row.type_name}}</template>
          </el-table-column>

          <el-table-column label="报警数值">
            <template slot-scope="scope">
              {{$sensortypeRound(scope.row.data_type, scope.row.value)}}
              
              <span style="color: darkgrey;font-size: 12px;">
                {{getUnit(scope.row.data_type)}}
              </span>
              
            </template>
          </el-table-column>
        </el-table>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from 'vuex'
import { waterTypes } from '@/option/option'
moment.defineLocale("zh-cn", {
  months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
    "_"
  ),
  monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
  weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
  weekdaysMin: "日_一_二_三_四_五_六".split("_"),
  longDateFormat: {
    LT: "Ah点mm分",
    LTS: "Ah点m分s秒",
    L: "YYYY-MM-DD",
    LL: "YYYY年MMMD日",
    LLL: "YYYY年MMMD日Ah点mm分",
    LLLL: "YYYY年MMMD日ddddAh点mm分",
    l: "YYYY-MM-DD",
    ll: "YYYY年MMMD日",
    lll: "YYYY年MMMD日Ah点mm分",
    llll: "YYYY年MMMD日ddddAh点mm分"
  },
  meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiemHour: function(hour, meridiem) {
    if (hour === 12) {
      hour = 0;
    }
    if (meridiem === "凌晨" || meridiem === "早上" || meridiem === "上午") {
      return hour;
    } else if (meridiem === "下午" || meridiem === "晚上") {
      return hour + 12;
    } else {
      // '中午'
      return hour >= 11 ? hour : hour + 12;
    }
  },
  meridiem: function(hour, minute, isLower) {
    var hm = hour * 100 + minute;
    if (hm < 600) {
      return "凌晨";
    } else if (hm < 900) {
      return "早上";
    } else if (hm < 1130) {
      return "上午";
    } else if (hm < 1230) {
      return "中午";
    } else if (hm < 1800) {
      return "下午";
    } else {
      return "晚上";
    }
  },
  calendar: {
    sameDay: function() {
      return this.minutes() === 0 ? "[今天]Ah[点整]" : "[今天]LT";
    },
    nextDay: function() {
      return this.minutes() === 0 ? "[明天]Ah[点整]" : "[明天]LT";
    },
    lastDay: function() {
      return this.minutes() === 0 ? "[昨天]Ah[点整]" : "[昨天]LT";
    },
    nextWeek: function() {
      var startOfWeek, prefix;
      startOfWeek = moment().startOf("week");
      prefix =
        this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? "[下]" : "[本]";
      return this.minutes() === 0 ? prefix + "dddAh点整" : prefix + "dddAh点mm";
    },
    lastWeek: function() {
      var startOfWeek, prefix;
      startOfWeek = moment().startOf("week");
      prefix = this.unix() < startOfWeek.unix() ? "[上]" : "[本]";
      return this.minutes() === 0 ? prefix + "dddAh点整" : prefix + "dddAh点mm";
    },
    sameElse: "LL"
  },
  ordinalParse: /\d{1,2}(日|月|周)/,
  ordinal: function(number, period) {
    switch (period) {
      case "d":
      case "D":
      case "DDD":
        return number + "日";
      case "M":
        return number + "月";
      case "w":
      case "W":
        return number + "周";
      default:
        return number;
    }
  },
  relativeTime: {
    future: "%s内",
    past: "%s前",
    s: "几秒",
    m: "1 分钟",
    mm: "%d 分钟",
    h: "1 小时",
    hh: "%d 小时",
    d: "1 天",
    dd: "%d 天",
    M: "1 个月",
    MM: "%d 个月",
    y: "1 年",
    yy: "%d 年"
  },
  week: {
    // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
});
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      timeRange: "",
      snSearch: "",
      // alarmList: [],
      alarmListFiltered: [],
      alarmTypeList: [],
      alarmType: "",
      isLoading: false
    };
  },
  filters: {
    name_f(v) {
      if (!v) {
        return v;
      }
      if (v.length > 5) {
        return v.slice(0, 5);
      } else {
        return v;
      }
    },
    time_f(v) {
      return moment(v)
        .startOf("min")
        .fromNow();
    }
  },
  mounted() {
    this.getAlarmList();
    this.getAlarmTypeList();
  },
  computed: {
    ...mapState(['alarmList'])
  },
  methods: {
    getAlarmList() {
      var self = this;
      var end_t = moment().format("YYYY-MM-DD HH:mm:ss");
      var start_t = moment()
        .subtract(3, "days")
        .format("YYYY-MM-DD HH:mm:ss");
      this.$store.dispatch("getAlarmList", {start_t, end_t}).finally(x=>{
        this.isLoading = false
      })
    },
    getUnit(data_type) {
      let info = waterTypes.find(x=>x.value === data_type)
      if (info) {
        return '' + info.unit + ''
      }else{
        return ''
      }
    },
    getAlarmTypeList() {
      var self = this;
      this.axios_base
        .get("alarm/getTbInfo?tb=alarm_wz_log_type_info")
        .then(function(resp) {
          self.alarmTypeList = resp.data;
        });
    },
    rowClick(e) {
      console.log(e);
      this.$router.push({ name: "detail", params: { id: e.id } });
    },
    onRefresh() {
      setTimeout(() => {
        this.getAlarmList();
      }, 200);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.alarmlist {
  height: calc(100vh - 100px);
}
</style>
<style>
.el-table__body-wrapper .el-table__row .cell {
  padding-left: 2px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/application/alarm/alarmList.vue